/**
 * Routes: /liegenschaften/ and below
 *
 * Will me merged into the router's 'route' array
 */
import LiegenschaftList from '@/views/auth/liegenschaft/LiegenschaftenList.vue'
import LiegenschaftForm from '@/views/auth/liegenschaft/LiegenschaftForm.vue'

export default [
    {
        path: '/liegenschaften',
        name: 'liegenschaften',
        component: LiegenschaftList,
        meta: {
            requiresAuth: true,
            title: 'Liegenschaften',
        },
        children: [
            {
                path: ':id',
                name: 'liegenschaft_edit',
                component: LiegenschaftForm,
                meta: {
                    requiresAuth: true,
                    title: (to: { params: { id: number | string } }) =>
                        `Liegenschaft: ${to.params.id}`,
                },
            },
        ],
    },
]
